const dollars = (value) => typeof value === 'number' && Number.isFinite(value)
  ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD', minimumFractionDigits: 6, maximumFractionDigits: 8 }).format(value)
  : 'Não determinado'
const tokens = (value) => Number.isSafeInteger(value) && value >= 0 ? value.toLocaleString('pt-BR') : 'Não informado'

export default function DraftGenerationUsage({ audit, uncertain = false }) {
  if (!audit && !uncertain) return null
  if (!audit) return <section className="acervo-notice" aria-label="Consumo da geração">
    <h4>Consumo não confirmado</h4>
    <p>A resposta não foi recebida. Uma chamada externa pode ter sido cobrada; confira o histórico do provedor antes de repetir a geração.</p>
  </section>
  const calls = Array.isArray(audit.calls) ? audit.calls : []
  return <section className="panaceia-generation-usage" aria-label="Consumo da geração">
    <h4>Consumo da geração · {audit.provider === 'claude' ? 'Claude' : 'Ollama local'}</h4>
    {audit.provider === 'claude' ? <>
      <p><strong>Custo estimado: {dollars(audit.estimatedCostUsd)}</strong></p>
      <p className="acervo-muted">Estimativa em USD a partir do uso retornado e das tarifas registradas. A cobrança final é apurada pela Anthropic.</p>
      {!audit.costComplete && <p className="acervo-notice">O custo está incompleto. Subtotal das chamadas com uso e tarifa confirmados: {dollars(audit.knownEstimatedSubtotalUsd)}. Isso não significa custo zero para as demais chamadas.</p>}
    </> : <p className="acervo-muted">O custo da infraestrutura local não foi estimado.</p>}
    <details>
      <summary>Detalhar {calls.length} chamada(s), incluindo recuperações</summary>
      {calls.map((call, index) => <article key={call.callId || index} className="judit-attachment">
        <h5>Chamada {index + 1} · {call.returnedModel || call.requestedModel || 'Modelo não informado'}</h5>
        <p>{call.phase === 'RECOVERY' ? 'Recuperação da minuta' : call.phase === 'INITIAL' ? 'Geração inicial' : 'Chamada ao provedor'}{call.attempt > 0 ? ` · tentativa ${call.attempt}` : ''}</p>
        <p>Estado: {call.state || 'Não informado'} · término: {call.stopReason || 'Não informado'}</p>
        <dl className="panaceia-usage-tokens">
          <div><dt>Entrada sem cache</dt><dd>{tokens(call.usage?.inputTokens)}</dd></div>
          <div><dt>Saída</dt><dd>{tokens(call.usage?.outputTokens)}</dd></div>
          <div><dt>Cache lido</dt><dd>{tokens(call.usage?.cacheReadInputTokens)}</dd></div>
          <div><dt>Cache gravado</dt><dd>{tokens(call.usage?.cacheCreationInputTokens)}</dd></div>
          <div><dt>Cache gravado · 5 minutos</dt><dd>{tokens(call.usage?.cacheCreation5mInputTokens)}</dd></div>
          <div><dt>Cache gravado · 1 hora</dt><dd>{tokens(call.usage?.cacheCreation1hInputTokens)}</dd></div>
        </dl>
        {audit.provider === 'claude' && <p>Estimativa desta chamada: {dollars(call.estimatedCostUsd)}</p>}
        {call.resultUncertain && <p className="acervo-notice">Resultado incerto. A chamada não foi repetida automaticamente.</p>}
        {call.warning && <p className="acervo-notice">{call.warning}</p>}
        {call.rates && <p className="acervo-muted">Tarifa: {call.rates.version} · referência {call.rates.effectiveDate}. <a href={call.rates.source} target="_blank" rel="noreferrer">Consultar fonte das tarifas</a>.</p>}
      </article>)}
    </details>
  </section>
}
